import { BasicService } from "./core/basic.service";

export class ConfigService extends BasicService {

  static async getList(tag) {
    const data = await this.http.post('/config/getConfig',{ tag });
    return Promise.resolve(data);
  }
  static async editConfig(query) {
    const data = await this.http.post('/config/editConfig',{config_arr:query})
    return Promise.resolve(data)
  }
}